import React from 'react';
import {
  ITEM_EFFECT_MODIFIERS,
  ITEM_STAT_MODIFIERS,
  appendEffectTag,
} from '../utils/itemStats';

interface ItemEffectModifiersProps {
  effect: string;
  onEffectChange: (next: string) => void;
}

export function ItemEffectModifiers({ effect, onEffectChange }: ItemEffectModifiersProps) {
  return (
    <div className="item-modifier-panel">
      <p className="form-help-text">
        Mögliche Modifikatoren — antippen, um sie in den Effekt zu schreiben:
      </p>
      <div className="item-modifier-chips" role="group" aria-label="Mögliche Modifikatoren">
        {ITEM_EFFECT_MODIFIERS.map(modifier => (
          <button
            key={modifier.snippet}
            type="button"
            className="item-modifier-chip"
            title={modifier.hint}
            onClick={() => onEffectChange(appendEffectTag(effect, modifier.snippet))}
          >
            <span className="item-modifier-chip-label">
              <span aria-hidden>{modifier.icon}</span> {modifier.label}
            </span>
            <small>{modifier.hint}</small>
          </button>
        ))}
      </div>
      <ul className="item-modifier-legend">
        {ITEM_STAT_MODIFIERS.map(stat => (
          <li key={stat.key}>
            <span aria-hidden>{stat.icon}</span> <strong>{stat.label}:</strong> {stat.hint}
          </li>
        ))}
      </ul>
    </div>
  );
}
